import { render, staticRenderFns } from "./reportZS.vue?vue&type=template&id=fb68fd80&scoped=true&"
import script from "./reportZS.vue?vue&type=script&lang=js&"
export * from "./reportZS.vue?vue&type=script&lang=js&"
import style0 from "./reportZS.vue?vue&type=style&index=0&id=fb68fd80&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb68fd80",
  null
  
)

export default component.exports